import React from "react"
import CircularProgress from 'material-ui/CircularProgress'
import strings from '../localization/strings';
import { getSSOAuthData } from "../actions/LoginActions"
import { browserHistory } from "react-router"
import AuthenticationStore from "../stores/AuthenticationStore"
const permissionHelper = require("../helpers/permissionHelper")
let ssoLoginInProgress = false

const SSO: React.SFC<any> = (props: any) => {
    if(!ssoLoginInProgress){
        ssoLoginInProgress = true
        //Clear all local cookie cache
        localStorage.setItem("findd_userId", "")
        localStorage.setItem("findd_accountId", "")
        localStorage.setItem("findd_ASPXAUTH", "")
        localStorage.setItem("findd_type", "")
        AuthenticationStore.deleteCookieAuth()

        getSSOAuthData(props.params.token).then((result)=>{
            if(!result){
                browserHistory.replace("/login")				
            }else{
                if (AuthenticationStore.isLoggedIn()) {
                    const loggedInUserType = permissionHelper.getLoggedInUserType()
                    let defaultUrl
                    switch (loggedInUserType) {
                        case AuthenticationStore.LoggedInUserTypes.AccountAdmin: {
                            defaultUrl = "/dashboard"
                            break
                        }
                        case AuthenticationStore.LoggedInUserTypes.AccountUser: {
                            defaultUrl = "/dashboard"
                            break
                        }
                        case AuthenticationStore.LoggedInUserTypes.Employee: {
                            defaultUrl = `/user-details/${AuthenticationStore.getLoggedInUser().Id}/timecards`
                            break
                        }
                    }
                    setTimeout(function() {
                        browserHistory.replace(defaultUrl)
                    }, 100)
                }
            }
        })
    }

    return (					
    <div style={{ paddingTop: 50, width:400, textAlign: "center", margin: "0px auto" }}>
        <div>
            <div style={{padding:50}}>
                <img src="/assets/logo.png" style={{width: 150}} />
            </div>
            <CircularProgress /> 
            <div>
                {strings.SSO_LOGIN_IN_PROGRESS}
            </div>
        </div>
    </div>)
}

export default SSO